import { mapGetters } from "vuex"

import { AccountService } from "@/services"
import { AddressBookService } from "@/services/AddressBookService"

export const countryHelper = {
  data: () => ({
    country: []  
  }),
  computed: {
    ...mapGetters([
      "user", 
      "activeAccountId"
    ]),
  },
  created(){   
    AddressBookService.GetCountries(this.activeAccountId, this.user.UserId).then(returnedCountries => {
      let mappedCountries = returnedCountries.map(function(country){
        return {
          id: country.CountryCode,
          label: country.Label
        }
      });
      
      this.country = mappedCountries
    });
  },
  methods: {
    getCountryLabel: function (countryId) {
      let obj = this.country.find(obj => obj.id === countryId)
      return obj
    }
  }
}
